import React, { useState } from 'react';
import { submitLead } from '../api';
import './LeadModal.css';

const INDUSTRIES = ['金融科技', '数字政府', '行业数字化', '通用方案', '云计算', '大数据', '人工智能', '区块链', '信创', '综合应用'];

export default function LeadModal({ isOpen, onClose }) {
  const [form, setForm] = useState({ name: '', company: '', phone: '', email: '', industry: '', message: '', agree: false });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const validate = () => {
    const e = {};
    if (!form.name || form.name.length < 2) e.name = '姓名须为 2~20 个字符';
    if (!form.company || form.company.length < 2) e.company = '公司名称须为 2~50 个字符';
    if (!/^1[3-9]\d{9}$/.test(form.phone)) e.phone = '请输入有效的手机号码';
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) e.email = '请输入有效的邮箱';
    if (!form.agree) e.agree = '请阅读并同意隐私政策';
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    try {
      await submitLead(form);
      setSuccess(true);
      setTimeout(() => { setSuccess(false); onClose(); setForm({ name:'',company:'',phone:'',email:'',industry:'',message:'',agree:false }); }, 3000);
    } catch (err) {
      setErrors({ submit: err.response?.data?.message || '提交失败，请稍后重试' });
    } finally {
      setLoading(false);
    }
  };

  const set = (key, val) => { setForm(f => ({ ...f, [key]: val })); setErrors(e => ({ ...e, [key]: '' })); };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>

        {success ? (
          <div className="modal-success">
            <div className="success-icon">✓</div>
            <h3>提交成功！</h3>
            <p>感谢您的咨询，我们的工作人员将在 1-3 个工作日内与您联系。</p>
          </div>
        ) : (
          <>
            <div className="modal-header">
              <h2>获取解决方案</h2>
              <p>留下您的联系方式，专业顾问将为您定制方案</p>
            </div>

            <form onSubmit={handleSubmit} className="modal-form">
              <div className="form-row">
                <div className={`form-field${errors.name ? ' error' : ''}`}>
                  <label>姓名 <span>*</span></label>
                  <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="请输入您的姓名" maxLength={20} />
                  {errors.name && <span className="form-error">{errors.name}</span>}
                </div>
                <div className={`form-field${errors.company ? ' error' : ''}`}>
                  <label>公司名称 <span>*</span></label>
                  <input value={form.company} onChange={e => set('company', e.target.value)} placeholder="请输入公司名称" maxLength={50} />
                  {errors.company && <span className="form-error">{errors.company}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className={`form-field${errors.phone ? ' error' : ''}`}>
                  <label>联系电话 <span>*</span></label>
                  <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="请输入手机号" maxLength={11} />
                  {errors.phone && <span className="form-error">{errors.phone}</span>}
                </div>
                <div className={`form-field${errors.email ? ' error' : ''}`}>
                  <label>邮箱</label>
                  <input value={form.email} onChange={e => set('email', e.target.value)} placeholder="请输入邮箱（选填）" type="email" />
                  {errors.email && <span className="form-error">{errors.email}</span>}
                </div>
              </div>

              <div className="form-field">
                <label>感兴趣的方案</label>
                <select value={form.industry} onChange={e => set('industry', e.target.value)}>
                  <option value="">请选择（选填）</option>
                  {INDUSTRIES.map(i => <option key={i} value={i}>{i}</option>)}
                </select>
              </div>

              <div className="form-field">
                <label>留言</label>
                <textarea
                  value={form.message}
                  onChange={e => set('message', e.target.value)}
                  placeholder="请描述您的需求（选填，最多 500 字）"
                  rows={3}
                  maxLength={500}
                />
              </div>

              <div className={`form-field form-agree${errors.agree ? ' error' : ''}`}>
                <label>
                  <input type="checkbox" checked={form.agree} onChange={e => set('agree', e.target.checked)} />
                  我已阅读并同意 <a href="/privacy" target="_blank">《隐私政策》</a>
                </label>
                {errors.agree && <span className="form-error">{errors.agree}</span>}
              </div>

              {errors.submit && <div className="form-error form-error-global">{errors.submit}</div>}

              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading ? '提交中...' : '立即获取方案'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
